<template>
  <div class="diets-manager-group">
    <v-alert v-if="status.type" fixed :type="status.type">{{status.mes}}</v-alert>
    <h3 class="mt-5 mb-5">Minhas dietas</h3>
    <div v-if="getDiets.length == 0" class="info-no-diets">
      <p>Dietas cadastradas serão usadas como base de cálculo para determinar as adequações calórica e protéica.</p>
    </div>
    <div class="diets">
      <app-diet
        v-on:deleteMessage="deleteMessage"
        v-on:update="update"
        v-for="(item, index) in getDiets"
        :key="index"
        :item="item"
      />
    </div>
    <v-dialog v-model="dialog" max-width="350px">
      <app-diet-create
        :updateDiet="updateDiet"
        v-on:toggleCreate="dialog = false"
        v-on:cleanUpdateDiet="cleanUpdateDiet"
        v-if="dialog"
      ></app-diet-create>
    </v-dialog>
    <v-btn
      @click="dialog = true"
      class="mx-2"
      dark
      fixed
      bottom
      right
      fab
      style="background: rgb(0, 96, 100);"
    >
      <v-icon dark>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "appDiets",
  data() {
    return {
      dialog: false,
      updateDiet: null,
      status: {
        type: "",
        mes: ""
      }
    };
  },
  computed: {
    getDiets() {
      return this.$store.getters["dietsBase/getDiets"];
    }
  },
  methods: {
    update(itemToUpdate, indexRef) {
      this.updateDiet = itemToUpdate;
      this.updateDiet.indexRef = indexRef;

      this.dialog = true;
    },
    cleanUpdateDiet() {
      this.updateDiet = null;
    },
    deleteMessage(statusFrom) {
      this.status.type = statusFrom.type;
      this.status.mes = statusFrom.mes;
      setTimeout(() => {
        this.status.type = "";
        this.status.mes = "";
      }, 1500);
    }
  },
  components: {
    AppDiet: () => import("./diet/Diet"),
    AppDietCreate: () => import("./diet/DietCreate")
  }
};
</script>

<style scoped>
.diets-manager-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  align-self: center;
}

.diets {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-around;
}
</style>